import { SaleEstimate } from '../../graphql.generated';

type RequiredEstimateValues = 'currentPrice' | 'lowerPrice' | 'upperPrice';

/**
 * This checks the current, lower and upper prices of a sale estimate object
 * to make sure that it is valid. It is used in the Estimate component itself
 * to govern the logic that shows the error message, but exported from the lib
 * to allow consumers of the Estimate component to use it to add other
 * contextual information without having to replicate the conditions themselves.
 * It also acts as a predicate to tell TS that the value passed in was indeed
 * a valid sale estimate so makes checks later on much easier
 *
 * @param  {Partial<SaleEstimate>} saleEstimate
 * @returns boolean
 */
export const isValidEstimate = (
    saleEstimate?: Pick<SaleEstimate, RequiredEstimateValues> | null
): saleEstimate is SaleEstimate => {
    return (
        !!saleEstimate &&
        saleEstimate.currentPrice > 0 &&
        saleEstimate.lowerPrice > 0 &&
        saleEstimate.upperPrice > 0
    );
};
